<ng-template #viewLabel></ng-template>
<ng-template #viewValue>
    <div class="pdf-component-container" #pdfComponent (window:resize)="onResize($event)">
        <ng2-pdfjs-viewer #pdfViewer class="viewer" [viewerId]="'pdf_' + value.id" [pdfSrc]="url" [openFile]="false"
            zoom="page-fit" [locale]="locale" [diagnosticLogs]="false" pagemode="none"
            (onDocumentLoad)="onPdfLoad($event)" [print]="false" [download]="false"></ng2-pdfjs-viewer>
    </div>
</ng-template>